import { usePropertyPageQuery } from '../../../../graphql/usePropertyPageQuery';
import { useBeforeYouBuyTimelineQuery } from '../../../../graphql/useBeforeYouBuyTimelineQuery';
import { PropertyTimelineBeforeYouBuy } from './PropertyTimelineBeforeYouBuy';
import { mapButtonVariant } from '../../../../../app-kit/helpers/mapButtonVariant';
import { mapIconName } from '../../../../../app-kit/helpers/mapIconName';
import { mapLinkIconPlacement } from '../../../../../app-kit/helpers/mapLinkIconPlacement';
import { mapDynamicContentItems } from '../../../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { useFeatureRollout } from '@rea-argonaut/experiment';

export const useBeforeYouBuyTimelineBrickData = () => {
  const toggleBYBLegalDisclaimers = useFeatureRollout('byb_legal_disclaimers').isEnabled();
  const timelineData = usePropertyPageQuery()?.data.propertyPageBySlugV3.timelineV4;
  const csrTimelineData = useBeforeYouBuyTimelineQuery();

  if (toggleBYBLegalDisclaimers) {
    const ssrData = timelineData?.beforeYouBuyV2;
    if (!ssrData) return null;

    const csrData = csrTimelineData?.data?.beforeYouBuyV2?.propertyPageTimelineBrickV3;
    return { ...(csrData ?? ssrData) };
  } else {
    const ssrData = timelineData?.beforeYouBuy;
    if (!ssrData) return null;
    const csrData = csrTimelineData?.data?.beforeYouBuyV2?.propertyPageTimelineBrick;

    const { title, subtitle, disclaimer, reportCTAV2 } = csrData ?? ssrData;

    return {
      title,
      subtitle,
      disclaimer,
      reportCTA: reportCTAV2,
    };
  }
};

export const PropertyTimelineBeforeYouBuyWithData = () => {
  const data = useBeforeYouBuyTimelineBrickData();
  if (!data) return null;

  const { title, subtitle, disclaimer, reportCTA } = data;

  return (
    <PropertyTimelineBeforeYouBuy
      title={title}
      subtitle={subtitle}
      disclaimer={mapDynamicContentItems(disclaimer)}
      reportCTA={{
        value: reportCTA.text,
        variant: mapButtonVariant(reportCTA.buttonVariant),
        icon: mapIconName(reportCTA.iconName),
        iconPlacement: mapLinkIconPlacement(reportCTA.iconPlacement),
      }}
    />
  );
};
